import _toConsumableArray from "/Users/nagatech/Documents/job/front-end/nagagold/nagagold_trancate/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
export default function getNewValue(value, oldValue, multiple) {
  if (!multiple) {
    return value;
  }

  if (!oldValue) {
    return [value];
  }

  var newValue = !Array.isArray(oldValue) ? [oldValue] : _toConsumableArray(oldValue);
  var valueIndex = newValue.findIndex(function (val) {
    return val === value;
  });

  if (valueIndex >= 0) {
    newValue.splice(valueIndex, 1);
  } else {
    newValue.push(value);
  }

  return newValue;
}